import { type FC, useEffect } from 'react'
import { type TextToSpeechWidgetStore } from 'widgets/TextToSpeech/store/textToSpeechWidgetStore'
import { type ITextToSpeechUiProps, TextToSpeechUi } from 'widgets/TextToSpeech/ui/TextToSpeechUi'
import { TextToSpeechContext } from '../context/context'

type ITextToSpeechProps = {
  store: TextToSpeechWidgetStore
} & ITextToSpeechUiProps

export const TextToSpeech: FC<ITextToSpeechProps> = ({ store, ...props }) => {
  useEffect(() => {
    store.init()
  }, [])
  return (
    <TextToSpeechContext.Provider value={store}>
      <TextToSpeechUi {...props} />
    </TextToSpeechContext.Provider>
  )
}
